var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './SeriesPoster.scss';
import { getSeriesColor } from '../../../utils/utils';
import PlaceHolder from '../../Assets/icons/kodansha_placeholder.png';
import useElementSize from '../../Hooks/useElementSize';
import { KodanshaColors } from '../../../utils/constants';
import InkyMageImg from '../../../Devon/Components/InkyMageImg/InkyMageImg';
var SeriesPoster = function (_a) {
    var src = _a.src, alt = _a.alt, _b = _a.ratio, ratio = _b === void 0 ? 140 : _b, hover = _a.hover, color = _a.color, isGray = _a.isGray, preloadImage = _a.preloadImage, _c = _a.s, s = _c === void 0 ? { width: 700 } : _c, m = _a.m, _d = _a.l, l = _d === void 0 ? { width: 400 } : _d, _e = _a.xl, xl = _e === void 0 ? { width: 600 } : _e, isOnSale = _a.isOnSale;
    // Pass the color which you got from the server
    var _f = __read(useElementSize(), 2), seriesRef = _f[0], _g = _f[1], width = _g.width, height = _g.height;
    return (_jsxs("div", { className: "ui-series-poster-container ".concat(hover !== false && 'ui-series-poster-container-hover'), style: { paddingTop: ratio + '%' }, children: [isOnSale && _jsx("span", { className: "on-sale ".concat(false ? 'on-sale-product-page' : ''), children: "ON SALE" }), _jsx("div", { className: 'ui-series-poster-container-2', children: _jsxs("div", { className: 'ui-series-poster-wrapper', ref: seriesRef, children: [src ?
                            _jsx(InkyMageImg, { className: 'ui-series-poster-image', src: src, alt: alt, preloadImage: preloadImage, s: s, m: m, l: l, xl: xl, width: 1200, height: 960, style: {
                                    width: src === '' && 'auto',
                                    filter: (isGray === false || color === 'none') && 'grayscale(0%)',
                                } })
                            :
                                _jsx("img", { src: PlaceHolder, fetchpriority: "low", loading: "lazy", alt: alt, className: 'ui-series-poster-image', "aria-label": 'image for ' + alt, style: { width: src === '' && 'auto', filter: (isGray === false || color === 'none') && 'grayscale(0%)' } }), _jsx("div", { style: {
                                backgroundColor: src ? getSeriesColor(color) : KodanshaColors.none,
                            }, className: 'colorize' })] }) })] }));
};
export default React.memo(SeriesPoster);
